import { ActionType, createReducer } from 'typesafe-actions';
import { fetchBuildingSettings } from './actions';
import { BuildingSettingsByBuilfingState, BuildingSettingsState } from './types';

export const initialState: BuildingSettingsByBuilfingState = {};
export const initialSettingsState: BuildingSettingsState = {
  settings: null,
  loading: false,
  error: null,
  isConfigured: true,
};

const handleBuildingSettingsRequest = (
  state: BuildingSettingsByBuilfingState,
  action: ActionType<typeof fetchBuildingSettings.request>,
): BuildingSettingsByBuilfingState => ({
  ...state,
  [action.payload.buildingUuid]: {
    ...initialSettingsState,
    ...state[action.payload.buildingUuid],
    error: null,
    loading: true,
  },
});

const handleBuildingSettingsSuccess = (
  state: BuildingSettingsByBuilfingState,
  action: ActionType<typeof fetchBuildingSettings.success>,
): BuildingSettingsByBuilfingState => ({
  ...state,
  [action.payload.params.buildingUuid]: {
    ...state[action.payload.params.buildingUuid],
    settings: {
      ...action.payload.response.data,
      acknowledgmentEnabled: !!action.payload.response.data?.acknowledgmentText,
    },
    loading: false,
    error: null,
    isConfigured: true,
  },
});

const handleBuildingSettingsFailure = (
  state: BuildingSettingsByBuilfingState,
  action: ActionType<typeof fetchBuildingSettings.failure>,
): BuildingSettingsByBuilfingState => ({
  ...state,
  [action.payload.params.buildingUuid]: {
    ...initialSettingsState,
    ...state[action.payload.params.buildingUuid],
    loading: false,
    error: action.payload.response,
    isConfigured: !action.payload.isConfigError,
  },
});

export const buildingSettingsReducer = createReducer(initialState)
  .handleAction(fetchBuildingSettings.request, handleBuildingSettingsRequest)
  .handleAction(fetchBuildingSettings.success, handleBuildingSettingsSuccess)
  .handleAction(fetchBuildingSettings.failure, handleBuildingSettingsFailure);

export default buildingSettingsReducer;
